import type { ModuleNav } from '@saas/ui';

export const CONTRACT_ADMIN_ROLES = ['owner', 'admin'];
/** 台帳を読める人 = read / write / manage のどれか（write できるものは読め、manage できるものは書ける） */
export const CONTRACT_READ = [
  'contract.contract.read.own',
  'contract.contract.read.team',
  'contract.contract.read.all',
  'contract.contract.write.own',
  'contract.contract.write.team',
  'contract.contract.write.all',
  'contract.contract.manage.own',
  'contract.contract.manage.team',
  'contract.contract.manage.all',
];
export const CONTRACT_WRITE = ['contract.contract.write.own', 'contract.contract.write.team', 'contract.contract.write.all', 'contract.contract.manage.own', 'contract.contract.manage.team', 'contract.contract.manage.all'];
export const CONTRACT_MANAGE = ['contract.contract.manage.own', 'contract.contract.manage.team', 'contract.contract.manage.all'];

export const contractNav: ModuleNav = {
  module: 'contract',
  items: [
    { label: '電子サイン', to: '/contract/esign', icon: 'edit', permission: CONTRACT_READ, description: '署名依頼・同意・署名・証拠保管' },
    { label: '契約台帳', to: '/contract', icon: 'description', end: true, permission: CONTRACT_READ, description: '契約書の保管・期限・状態' },
    { label: '新しい契約', to: '/contract/new', icon: 'add', permission: CONTRACT_WRITE, description: '契約書を台帳に登録する' },
    { label: '期限アラート', to: '/contract/alerts', icon: 'schedule', permission: ['contract.alert.read'], description: '解約通知・満了・義務の期日' },
    { label: '検索（電帳法）', to: '/contract/search', icon: 'search', permission: CONTRACT_READ, description: '締結日・金額・取引先・本文' },
  ],
  admin: [
    { label: '電子サインの設定', to: '/contract/esign/settings', icon: 'settings', permission: ['contract.esign.policy.manage'], description: '署名基盤・法務確認・送信と同意受付' },
    { label: '保存期限と廃棄', to: '/contract/admin/retention', icon: 'inventory', roles: CONTRACT_ADMIN_ROLES, permission: ['contract.retention.manage'], description: '保存期限が来た契約書の廃棄 / 継続保管' },
    { label: '契約書管理の設定', to: '/contract/admin/settings', icon: 'settings', roles: CONTRACT_ADMIN_ROLES, permission: ['contract.settings.manage'], description: '期限アラートの休日・電子契約サービスとの接続' },
  ],
};
